export const assetItemData = [
  {
    assetCode: "AHU-001",
    assetName: "Pre Filter 20x20x2",
    category: "HVAC",
    subcategory: "AHU Filters",
    assignedTo: "Maintenance Team",
    location: "Mumbai Plant",
    purchaseDate: "2023-01-15",
    warranty: 6, // in months
    status: "Active",
  },
  {
    assetCode: "AHU-002",
    assetName: "HEPA Filter H13",
    category: "HVAC",
    subcategory: "AHU Filters",
    assignedTo: "Cleanroom A",
    location: "Hyderabad Facility",
    purchaseDate: "2022-12-10",
    warranty: 12,
    status: "Active",
  },
  {
    assetCode: "AHU-003",
    assetName: "Carbon Filter 18x24x2",
    category: "HVAC",
    subcategory: "AHU Filters",
    assignedTo: "Lab Section B",
    location: "Bangalore Unit",
    purchaseDate: "2023-03-20",
    warranty: 12,
    status: "Inactive",
  },
  {
    assetCode: "AHU-004",
    assetName: "Fine Filter F7",
    category: "HVAC",
    subcategory: "AHU Filters",
    assignedTo: "Production Floor 1",
    location: "Chennai Plant",
    purchaseDate: "2023-07-05",
    warranty: 12,
    status: "Active",
  },
  {
    assetCode: "AHU-005",
    assetName: "Bag Filter 25mm",
    category: "HVAC",
    subcategory: "AHU Filters",
    assignedTo: "Warehouse A",
    location: "Delhi HQ",
    purchaseDate: "2023-09-18",
    warranty: 12,
    status: "Active",
  },
  {
    assetCode: "AHU-006",
    assetName: "Panel Filter 24x24x2",
    category: "HVAC",
    subcategory: "AHU Filters",
    assignedTo: "HVAC Room 3",
    location: "Pune Facility",
    purchaseDate: "2022-10-25",
    warranty: 6,
    status: "Inactive",
  },
  {
    assetCode: "AHU-007",
    assetName: "HEPA Filter H14",
    category: "HVAC",
    subcategory: "AHU Filters",
    assignedTo: "Cleanroom B",
    location: "Noida Office",
    purchaseDate: "2023-05-30",
    warranty: 12,
    status: "Active",
  },
  {
    assetCode: "AHU-008",
    assetName: "Metal Mesh Filter",
    category: "HVAC",
    subcategory: "AHU Filters",
    assignedTo: "Air Intake Unit",
    location: "Kolkata Branch",
    purchaseDate: "2021-11-05",
    warranty: 24,
    status: "Inactive",
  },
  {
    assetCode: "AHU-009",
    assetName: "Activated Carbon Filter",
    category: "HVAC",
    subcategory: "AHU Filters",
    assignedTo: "Odor Control Unit",
    location: "Ahmedabad Site",
    purchaseDate: "2022-06-12",
    warranty: 18,
    status: "Active",
  },
  {
    assetCode: "AHU-010",
    assetName: "Mini Pleat Filter",
    category: "HVAC",
    subcategory: "AHU Filters",
    assignedTo: "Server Room",
    location: "Jaipur Office",
    purchaseDate: "2023-01-10",
    warranty: 12,
    status: "Active",
  },
];
